// extracted by mini-css-extract-plugin
module.exports = {"container":"sub-page-client-points-module--container--2aL1c","isFluid":"sub-page-client-points-module--is-fluid--3db6i","line":"sub-page-client-points-module--line--2i639"};